<template>
    <PointsProgram :listOffersAvailable="listOffersAvailableLocal"/>
</template>

<script>
//Store
import { mapGetters } from "vuex";

//Services
import { getAvailableOffersByCompanyIdAndCurrentContactId } from "@/app/components/points-program/service/points-program.service";

//Components
import PointsProgram from "@/app/components/points-program/pointsProgram";

export default {
    name: "Points-Program-view",
    components: { PointsProgram },
    computed: {
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        )
    },
    data: () => ({
        listOffersAvailableLocal: []
    }),
    created() {
        this.getOffersListAvailable()
    },
    methods: {
        getOffersListAvailable() {
            getAvailableOffersByCompanyIdAndCurrentContactId( this.currentCompany.id )
                .then( success => {
                        this.listOffersAvailableLocal = success.data
                    } 
                )
                .catch( error => {
                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        }
    }
}
</script>

<style>

</style>